"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _MiniProgressBar = require("./MiniProgressBar.styles");

var _iconNames = _interopRequireDefault(require("../../../constants/iconNames"));

var _text = require("../../../styles/2_commonComponentStyles/text");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Mini Progress Bar, primarily used to indicate file upload completion
 */
var MiniProgressBar = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(MiniProgressBar, _React$PureComponent);

  var _super = _createSuper(MiniProgressBar);

  function MiniProgressBar() {
    _classCallCheck(this, MiniProgressBar);

    return _super.apply(this, arguments);
  }

  _createClass(MiniProgressBar, [{
    key: "optionalLeftIcon",
    value: function optionalLeftIcon() {
      var _this$props = this.props,
          leftIconColorTheme = _this$props.leftIconColorTheme,
          leftIconName = _this$props.leftIconName,
          leftIconSpin = _this$props.leftIconSpin;
      return /*#__PURE__*/_react.default.createElement(_Icon.default, {
        className: [leftIconSpin ? 'c-mini-progress-bar-spinner' : undefined, 'c-mini-progress-bar-left-icon'].join(' '),
        colorTheme: leftIconColorTheme,
        dataTestId: "mini-progress-bar-left-icon",
        iconName: leftIconName,
        size: "small"
      });
    }
  }, {
    key: "optionalRightIcon",
    value: function optionalRightIcon() {
      var _this$props2 = this.props,
          rightIconClickHandler = _this$props2.rightIconClickHandler,
          rightIconColorTheme = _this$props2.rightIconColorTheme,
          rightIconName = _this$props2.rightIconName,
          barAnimation = _this$props2.barAnimation,
          percentComplete = _this$props2.percentComplete,
          rightIconFadeIn = _this$props2.rightIconFadeIn;
      return /*#__PURE__*/_react.default.createElement(_MiniProgressBar.StyledRightIcon
      /** Since this is just for a style, it needs to be written this way */
      , {
        waitforprogressbarcompletion: barAnimation && percentComplete === 100 ? 'true' : 'false',
        fadein: rightIconFadeIn ? 'true' : 'false',
        colorTheme: rightIconColorTheme,
        dataTestId: "mini-progress-bar-right-icon",
        iconName: rightIconName,
        onClick: rightIconClickHandler,
        size: "small"
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          barAnimation = _this$props3.barAnimation,
          className = _this$props3.className,
          dataTestId = _this$props3.dataTestId,
          error = _this$props3.error,
          leftIconColorTheme = _this$props3.leftIconColorTheme,
          leftIconName = _this$props3.leftIconName,
          leftIconSpin = _this$props3.leftIconSpin,
          percentComplete = _this$props3.percentComplete,
          progressMessage = _this$props3.progressMessage,
          progressMessageColor = _this$props3.progressMessageColor,
          rightIconClickHandler = _this$props3.rightIconClickHandler,
          rightIconColorTheme = _this$props3.rightIconColorTheme,
          rightIconName = _this$props3.rightIconName,
          rightIconFadeIn = _this$props3.rightIconFadeIn,
          props = _objectWithoutProperties(_this$props3, ["barAnimation", "className", "dataTestId", "error", "leftIconColorTheme", "leftIconName", "leftIconSpin", "percentComplete", "progressMessage", "progressMessageColor", "rightIconClickHandler", "rightIconColorTheme", "rightIconName", "rightIconFadeIn"]);

      var displayPercent = percentComplete > 100 ? 100 : percentComplete;
      return /*#__PURE__*/_react.default.createElement(_MiniProgressBar.StyledMiniProgressBar, {
        className: className,
        "data-test-id": dataTestId
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "c-mini-progress-bar-label"
      }, /*#__PURE__*/_react.default.createElement("span", null, leftIconName.length > 0 && this.optionalLeftIcon(), "\xA0", /*#__PURE__*/_react.default.createElement(_MiniProgressBar.ProgressMessage, {
        colorTheme: progressMessageColor,
        className: "c-mini-progress-bar-message"
      }, progressMessage)), rightIconName.length > 0 && this.optionalRightIcon()), /*#__PURE__*/_react.default.createElement("div", _extends({}, props, {
        className: "c-mini-progress-bar-wrapper"
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: ['c-mini-progress-bar-percent-complete', barAnimation ? 'c-mini-progress-bar-animation' : undefined, error ? 'c-mini-progress-bar-error' : undefined].join(' '),
        style: {
          width: "".concat(displayPercent, "%")
        }
      })));
    }
  }]);

  return MiniProgressBar;
}(_react.default.PureComponent);

_defineProperty(MiniProgressBar, "propTypes", {
  /** Turns on an animation transition for changes to the percent complete */
  barAnimation: _propTypes.default.bool,

  /** Hook for overriding top-level component styles */
  className: _propTypes.default.string,

  /** Test ID hook */
  dataTestId: _propTypes.default.string.isRequired,

  /** Flag that tells component to display an error-colored bar instead of the standard color */
  error: _propTypes.default.bool,

  /** left icon name - name of icon to display on the left side of the progress bar */
  leftIconName: _propTypes.default.oneOf(_iconNames.default),

  /** left icon color - color of icon to display on the left side of the progress bar */
  leftIconColorTheme: _propTypes.default.oneOf(_text.textThemes),

  /** left icon spin - should the icon have a spin animation applied */
  leftIconSpin: _propTypes.default.bool,

  /** percent complete - text displays on the bar once >= 10% */
  percentComplete: _propTypes.default.number,

  /** progress message - text to display progress status */
  progressMessage: _propTypes.default.string,

  /** progress message color - color of progress status text */
  progressMessageColor: _propTypes.default.oneOf(_text.textThemes),

  /** right icon name - name of icon to display on the right side of the progress bar */
  rightIconClickHandler: _propTypes.default.func,

  /** right icon color - color of icon to display on the right side of the progress bar */
  rightIconColorTheme: _propTypes.default.oneOf(_text.textThemes),

  /** Allows for a fade in for the right icon. Useful when an icon is only shown on completion */
  rightIconFadeIn: _propTypes.default.bool,

  /** right icon name - name of icon to display on the right side of the progress bar */
  rightIconName: _propTypes.default.oneOf(_iconNames.default)
});

_defineProperty(MiniProgressBar, "defaultProps", {
  className: '',
  barAnimation: false,
  error: false,
  rightIconFadeIn: true,
  percentComplete: 100,
  progressMessage: '',
  progressMessageColor: 'default',
  leftIconColorTheme: 'primary',
  leftIconSpin: false,
  leftIconName: '',
  rightIconClickHandler: function rightIconClickHandler() {},
  rightIconColorTheme: 'primary',
  rightIconName: ''
});

var _default = MiniProgressBar;
exports.default = _default;